import React from 'react';
import './sec1-home.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from '../components/common/cta';
import { useNavigate } from 'react-router-dom';
const Sec1home = () => {



 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);



 const [event, setevent]= useState([]);
      useEffect(() => {
      const getevent = async()=>{
          const res = await supabase.from('exbition_event').select('*').order('id', { ascending: true });;;
    
      setevent(res.data);
      }
      getevent();
      }, []);




      const navigate = useNavigate();

    return (  
        <section className='sec1-home'>

            <h1 className='header-section'>{content?.[24]?.header}</h1>

            <section className='containersec1-card'>
                <article className='card-sec1'>
                    <div className='card-info'>
                        <img className='img-sec1-home' src={event?.[0]?.img} alt={event?.[0]?.alt} />

                        <h2 className='header-sec1-card'>{event?.[0]?.mobile_header}</h2>

                        <button className='button-sec1'>
                            <Cta title={content?.[24]?.cta}  onClick={() => navigate('/eventdetails')}/>
                        </button>
                    </div>
                </article>
            </section>
        </section>
    );
}
 
export default Sec1home;